<main class="main c111">
    <article class="card box tarjeta-btn">
        <section>
            <h2>Modal de alerta</h2>
            <p>Es un modal estandarizado para mensajes o avisos, puede contener cualquier elmenento o fragmento HTLM en su interior renderizado de un string.</p>
            <p>ej: {{htmlString}}</p>    
        </section>
        <button class="btn btn-primary end" (click)="abrirAlerta()">Alerta</button>
    </article>

    <article class="card box tarjeta-btn">
        <section>
            <h2>Modal de alerta</h2>
            <p>Utiliza el mismo componente que el modal de alerta, pero pasandole la bandera [confirm]=true</p>
            <p>La respuesta se puede validar a través del emiter (acepta) que devuelve un true o un false</p>
        </section>
        <button class="btn btn-primary end" (click)="abrirConfirmacion()">Confirmacion</button>
    </article>

    <article class="card box ">
        <p class="alert error-mensaje">!ERROR: Mensaje de advertencia/error básico</p>
        <br/>
        <div class="alert alert-warning">
            <h3>Advertencia CON DETALLE </h3>
            <P>un mensaje de error con descripcion detallada si se quiere</P>
        </div>
        <div class="alert alert-danger">
            <h3>ERROR CON DETALLE </h3>
            <label> CODIGO: 123</label>
            <P>un mensaje de error con descripcion detallada si se quiere</P>
        </div>
    </article>
</main>